import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<firebase.User | null>(null);
  public currentUser$: Observable<firebase.User | null> =
    this.currentUserSubject.asObservable();
  constructor(private afAuth: AngularFireAuth, private router: Router) {
    this.afAuth.authState.subscribe((user) => {
      this.currentUserSubject.next(user);
    });
  }

  async getIdToken(): Promise<string | null> {
    const user = await this.afAuth.currentUser;
    if (user) {
      return await user.getIdToken();
    }
    return null;
  }
  async signInWithEmailPassword(
    email: string,
    password: string
  ): Promise<firebase.User | null> {
    const result = await this.afAuth.signInWithEmailAndPassword(
      email,
      password
    );
    return result.user;
  }
  async signInWithPhoneNumber(
    phoneNumber: string,
    appVerifier: firebase.auth.ApplicationVerifier
  ): Promise<firebase.auth.ConfirmationResult> {
    return await this.afAuth.signInWithPhoneNumber(phoneNumber, appVerifier);
  }
  async signInWithEmailAndPassword(
    email: string,
    password: string
  ): Promise<firebase.User | null> {
    const result = await this.afAuth.signInWithEmailAndPassword(
      email,
      password
    );
    return result.user;
  }
  async signInWithCustomToken(token: string): Promise<firebase.User | null> {
    const result = await this.afAuth.signInWithCustomToken(token);
    return result.user;
  }
  public async reload() {
    return (await this.afAuth.currentUser)?.reload();
  }
  async signOut(): Promise<void> {
    await this.afAuth.signOut();
    this.currentUserSubject.next(null);
    this.router.navigate(['/auth/sign-in']);
  }
  public async deleteUserAccount() {
    return (await this.afAuth.currentUser)?.delete();
  }
}
